import PopstateEventHandler from 'actions/current_location/popstate_event_handler';

export default function (context) {
  const handler = new PopstateEventHandler(context);

  // listen for browser navigation events and reset our internal history to prevent sync issues
  window.addEventListener('popstate', handler.createBrowserNavHandler());
}
